import { Injectable } from '@angular/core';
import { AwsApiWrapperService } from '@brightside-web/desktop/data-access/core-services';
import { Observable, from, map } from 'rxjs';
import { Contest } from './pls.model';

@Injectable()
export class PlsService {
  constructor(private _bsApi: AwsApiWrapperService) {}

  getContestInfo(): Observable<Contest[]> {
    return from(this._bsApi.get('api-mobile', '/contests-app-api/v2')).pipe(map((res) => res.contests));
  }

  updateContestInfo(contestId: number | undefined, contest: Contest) {
    return from(this._bsApi.post('api-mobile', `/contests-app-api/v2/${contestId}/results`, { body: contest }));
  }
}
